module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-06.92c6e226.svg";